import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "~/components/ui/dialog";
import type { Account, AccountFormData } from "~/types/contabilidad";

import { CuentaForm } from "./CuentaForm";

interface CuentaDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  account?: Account;
  onSubmit: (data: AccountFormData) => void;
  isLoading?: boolean;
}

export function CuentaDialog({
  open,
  onOpenChange,
  account,
  onSubmit,
  isLoading = false,
}: CuentaDialogProps) {
  const isEditing = !!account;

  const handleSubmit = (data: AccountFormData) => {
    onSubmit(data);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-2xl sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>
            {isEditing ? "Editar Cuenta" : "Nueva Cuenta"}
          </DialogTitle>
          <DialogDescription>
            {isEditing
              ? "Modifique los datos de la cuenta."
              : "Complete los datos para crear una nueva cuenta."}
          </DialogDescription>
        </DialogHeader>

        <CuentaForm
          initialData={account}
          onSubmit={handleSubmit}
          isLoading={isLoading}
          submitLabel={isEditing ? "Actualizar" : "Crear Cuenta"}
        />
      </DialogContent>
    </Dialog>
  );
}
